// Client API frontend pour le rappel de saisie kilométrique (véhicules hors suivi Océan) :
// jour/heure d'envoi automatique + liste des véhicules pour l'envoi manuel centralisé.

const BASE = "https://support.gs-group.fr/api";
const tok = () => localStorage.getItem("nexo_token");
const h = () => ({ Authorization: "Bearer " + tok() });
const hJson = () => ({ ...h(), "Content-Type": "application/json" });

async function getConfig() {
  return fetch(`${BASE}/km-reminder-config`, { headers: h() }).then(r => r.json());
}

/** @param {{enabled:boolean, jourSemaine:number, heure:string}} cfg */
async function saveConfig(cfg) {
  const r = await fetch(`${BASE}/km-reminder-config`, { method: "POST", headers: hJson(), body: JSON.stringify(cfg) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

/** Véhicules hors suivi Océan (rappel manuel possible), avec leur dernier relevé. */
async function getVehicules() {
  const d = await fetch(`${BASE}/km-reminder-config/vehicules`, { headers: h() }).then(r => r.json()).catch(() => []);
  return Array.isArray(d) ? d : [];
}

/** Envoie immédiatement le rappel à tous les véhicules hors Océan sans relevé cette semaine. */
async function sendAll() {
  const r = await fetch(`${BASE}/km-reminder-config/send-all`, { method: "POST", headers: h() });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

/** Envoie le rappel à un véhicule précis. */
async function sendOne(vehiculeId) {
  const r = await fetch(`${BASE}/vehicules/${vehiculeId}/send-km-reminder`, { method: "POST", headers: hJson() });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

export const kmReminderApi = { getConfig, saveConfig, getVehicules, sendAll, sendOne };
